import React, { Component } from 'react';
import Toggle from './base-components/Switch'
import TextInput from './base-components/TextInput'
import Select from './base-components/Select'
import NumberInput from './base-components/NumberInput';
import Slider from './base-components/Slider';

export default class FormItem extends Component {
    state = {
        checked: this.props.checked,
        height: this.props.hidden? "0px": "70px",
        opacity: this.props.hidden? "0%": "100%",
        padding: this.props.hidden? "0px": "10px",
        border: this.props.hidden? "none": "1px #ccc dotted",
        zIndex: this.props.hidden? "0": "1",
    }

    static getDerivedStateFromProps(props){
        return {
            height: props.hidden? "0px": "70px",
            opacity: props.hidden? "0%": "100%",
            padding: props.hidden? "0px": "10px",
            border: props.hidden? "none": "1px #ccc dotted",
            zIndex: props.hidden? "0": "1"
        }
    }

    getDivStyle = () => {
        return { 
            display: "flex",
            position: "relative",
            padding: this.state.padding,
            borderBottom: this.state.border,
            textAlign: "left",
            height: this.state.height,
            opacity: this.state.opacity,
            zIndex: this.state.zIndex,
            width: "100%",
            flexFlow: "row wrap",
            //transition: this.props.hidden !== undefined? "height 0.1s, opacity 0.1s, padding 0.1s": ""
        };
    };

    getInput = (type) => {
        switch (type) {
            case "text":
                return (
                    <TextInput value={this.props.value} placeholder={this.props.placeholder} handleChange={this.props.handleChange}></TextInput>
                );
            case "switch":
                return (
                    <Toggle handleChange={this.props.handleChange} checked={this.props.checked} disabled={this.props.disabled}></Toggle>
                );
            case "select":
                return (
                    <Select options={this.props.options} handleChange={this.props.handleChange} disabled={this.props.disabled} value={this.props.value} fill={this.props.fill}></Select>
                );
            case "number":
                return (
                    <NumberInput value={this.props.value} step={this.props.step} min={this.props.min} max={this.props.max} digits={this.props.digits} handleChange={this.props.handleChange} disabled={this.props.disabled}></NumberInput>
                );
            case "slider":
                let value = (this.props.value === undefined? 100: this.props.value);
                value = (this.props.min === undefined || this.props.value >= this.props.min? value: this.props.min);
                return (
                    <Slider value={value} step={this.props.step} min={this.props.min} max={this.props.max} handleChange={this.props.handleChange} disabled={this.props.disabled}></Slider>
                );
            default:
                return {};
        }
    };

    render() {
        return (
            <div id={this.props.id} className="form-item" style={this.getDivStyle()}>
                <label className="form-item">{this.props.text}</label>
                {this.getInput(this.props.inputType)}
            </div>
        )
    }
}
